import React from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";

// Checkbox glyphs traced 1:1 from the Figma export: 16x16, rx=2, #6D72F6 fill,
// exact white check path (translated to a 16x16 box).
const CheckedIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="2" fill="#6D72F6" />
        <path
            d="M7.105 12.6041L7.0873 12.6217L2.6875 8.2218L4.1202 6.7892L7.105 9.774L11.879 5L13.3117 6.4327L7.1226 12.6218L7.105 12.6041Z"
            fill="white"
        />
    </svg>
);

const UncheckedIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.5" fill="#fff" stroke="#C4C4C4" strokeWidth="1.5" />
    </svg>
);

// Reason/observation checkbox row (Figma "Reason Checkbox component"):
// unchecked = plain; checked = purple box + a lavender pill (#F7F7FF fill,
// #D4D5FC border) hugging the row. Reusable across option-list checkboxes.
// `plain` drops the pill highlight/padding for a bare checkbox + label (e.g.
// the acknowledgement row). Clicking the label always toggles the box.
export default function PillCheckbox({
    checked = false,
    onChange = () => {},
    label,
    labelSize = 15,
    labelWeight = 400,
    plain = false,
    disabled = false,
    testId,
}) {
    return (
        <FormControlLabel
            disabled={disabled}
            sx={{
                m: 0,
                minHeight: "32px",
                pl: plain ? 0 : "8px",
                pr: plain ? 0 : "14px",
                borderRadius: "10px",
                width: "fit-content",
                border: "1px solid transparent",
                backgroundColor: !plain && checked ? "#F7F7FF" : "transparent",
                borderColor: !plain && checked ? "#D4D5FC" : "transparent",
            }}
            control={
                <Checkbox
                    data-testid={testId}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    disableRipple
                    icon={UncheckedIcon}
                    checkedIcon={CheckedIcon}
                    sx={{ p: 0, mr: "11px" }}
                />
            }
            label={
                <Typography
                    sx={{
                        fontSize: `${labelSize}px`,
                        fontWeight: labelWeight,
                        color: disabled ? "#A8A8A8" : "#1A1A1A",
                    }}
                >
                    {label}
                </Typography>
            }
        />
    );
}
